import EbayTypes from "./ebay.types";

// Fetch eBay status. Only dispatch this on: app load/reload, after eBay
// OAuth login, after policies are updated/saved, after eBay disconnect,
// and after logging in to the main app.
export const fetchEbayStatusRequest = () => ({
  type: EbayTypes.FETCH_EBAY_STATUS_REQUEST,
});

export const fetchEbayStatusSuccess = (status) => ({
  type: EbayTypes.FETCH_EBAY_STATUS_SUCCESS,
  payload: status,
});

export const fetchEbayStatusFailure = (error) => ({
  type: EbayTypes.FETCH_EBAY_STATUS_FAILURE,
  payload: error,
});
